import { createFileRoute, useParams } from "@tanstack/react-router";
import RowFactsWorkbenchPage from "@/features/knowledges/RowFactsWorkbenchPage";

export const Route = createFileRoute("/_admin/knowledges/$knowledgeId/row-facts")({
  staticData: {
    breadcrumb: { label: "Row facts" },
  },
  component: RowFactsRoute,
});

function RowFactsRoute() {
  const { knowledgeId } = useParams({ strict: false }) as { knowledgeId: string };
  return <RowFactsWorkbenchPage knowledgeId={knowledgeId} />;
}
